<template>
  <div id="adminWrapper">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  created () {
    this.$store.dispatch('users/loadAll')
    this.$store.dispatch('items/loadAll')
    this.$store.dispatch('tables/loadAll')
    this.$store.dispatch('bundles/loadAll')
    this.$store.dispatch('columns/loadAll')
    this.$store.dispatch('dossiers/loadAll')
  }
}
</script>
